module.exports = __webpack_public_path__ + "static/fonts/materialdesignicons-webfont.64b9682.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mdi/font/fonts/materialdesignicons-webfont.ttf?v=2.7.94
// module id = j3yK
// module chunks = 0